import { Button, Modal, Space } from "antd";
import React, { useEffect } from "react";

import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import styles from "./ModalEvSearchInfo.module.css";

function ModalEvSearchInfo({ openModal, onChangedOpenModal }: { openModal: boolean; onChangedOpenModal: (opened: boolean) => void }) {
    useEffect(() => {
        if (openModal === true) Utils.addModalStack();
        else Utils.popModalStack();
    }, [openModal]);

    const handleDonotShowInfo = () => {
        // TODO: Utils.setLocalStorage(Common.CONTEXT_DONOT_SHOW_EVINFO, "true");
    };

    return (
        <Modal
            centered
            className={styles.confirmModal}
            key="modalEvSearchInfo"
            open={openModal}
            closable={false}
            onCancel={() => onChangedOpenModal(false)}
            footer={false}
        >
            <div className={styles.modalText}>
                <div>에러 발생률이 낮은</div>
                <div>
                    <span style={{ color: "#3B6BCC", fontWeight: 700, fontSize: 16 }}>대영채비, 시그넷</span>의 급속 충전기만
                </div>
                <div style={{ marginBottom: "8px" }}>이용하실 것을 권고 드리며,</div>

                <div>현재 충전소 찾기 기능은</div>
                <div>
                    <span style={{ color: "#3B6BCC", fontWeight: 700, fontSize: 16 }}>대영채비, 시그넷</span>의
                </div>
                <div>급속 충전기가 설치되어 있는</div>
                <div>충전소 위치만 안내드립니다.</div>
            </div>
            <Space>
                <Button
                    key="notShow"
                    className={styles.secondaryBtn}
                    onClick={() => {
                        handleDonotShowInfo();
                        onChangedOpenModal(false);
                    }}
                >
                    다시 보지 않기
                </Button>
                <Button className={styles.primaryBtn} type="primary" key="confirm" onClick={() => onChangedOpenModal(false)}>
                    확인
                </Button>
            </Space>
        </Modal>
    );
}

export default ModalEvSearchInfo;
